<template>
    <div class="change-pass">
        <div class="wrapper">
            <img
                class="logo"
                :src="require('@/assets/moodmix-logo.png')"
            />

            <form class="form" @submit.prevent="save()">
                <p>Please enter your new password</p>

                <div class="form-wrapper">
                    <span class="label">New Password</span>
                    <div class="password-wrapper">
                        <input
                            v-model="pass"
                            class="password"
                            :type="showPass ? 'text' : 'password'"
                            placeholder="New password"
                            required
                        >
                        <p class="show" @click="showPass = !showPass">{{ showPass ? 'Hide' : 'Show' }}</p>
                        <p class="error" v-if="error && error.password">{{ error.password[0] }}</p>
                    </div>
                </div>
                
                <div class="form-wrapper">
                    <span class="label">Confirm new password</span>
                    <div class="password-wrapper">
                        <input
                            v-model="confirmPass"
                            class="password"
                            :type="showConfirmPass ? 'text' : 'password'"
                            placeholder="Confirm new password"
                            required
                        >
                        <p class="show" @click="showConfirmPass = !showConfirmPass">{{ showConfirmPass ? 'Hide' : 'Show' }}</p>
                    </div>
                </div>

                <button class="login" type="submit" :disabled="loading">Send</button>
            </form>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
	props: ['token'],

	data () {
		return {
			pass: '',
			confirmPass: '',
			error: null,
			showPass: false,
			showConfirmPass: false,
		}
	},
    
	computed: {
		...mapState({
			loading: state => state.loading,
		})
	},
    
	methods: {
		async save () {
			this.error = await this.$store.dispatch('changePass', {
				token: this.token,
				password: this.pass,
				password_confirmation: this.confirmPass
			})
		}
	},
}
</script>

<style lang="scss" scoped>
.change-pass {
    padding-top: 55px;

    .wrapper {
        display: flex;
        flex-direction: column;
        margin: auto;
        width: 400px;

        @include mobile {
            width: 300px;
        }

        .logo {
            width: 123px;
            height: 61px;
            margin: 0 auto 35px;
        }

        .form {
            display: flex;
            flex-direction: column;

            p {
                font-size: 12px;
                color: #ffffff;
                margin-bottom: 15px;
            }

            .form-wrapper {
                display: flex;
                flex-direction: column;
                margin-bottom: 40px;
                
                .label {
                    color: #ffffff;
                    margin-bottom: 10px;
                }

                .error {
                    text-align: right;
                    color: #F4949A;
                    font-size: 12px;
                }
    
                .password-wrapper {
                    position: relative;
    
                    .password {
                        width: 100%;
                        padding-right: 45px;
                    }
    
                    .show {
                        color: #BFCCE2;
                        position: absolute;
                        top: 7px;
                        right: 10px;
                        cursor: pointer;
                    }
                }
    
                input {
                    padding: 5px;
                    border: 1px solid #BFCCE2;
                    border-radius: 3px;
                    opacity: 1;
                    margin-bottom: 5px;
                    height: 32px;
    
                    &::placeholder {
                        opacity: 1;
                        color: #BFCCE2;
                        font-size: 12px;
                    }
                }
            }


            button {
                width: 242px;
                margin: auto;
            }
        }
    }
}
</style>